import { render, staticRenderFns } from "./AdElement.vue?vue&type=template&id=1dacede2&scoped=true&"
import script from "./AdElement.vue?vue&type=script&lang=js&"
export * from "./AdElement.vue?vue&type=script&lang=js&"
import style0 from "./AdElement.vue?vue&type=style&index=0&id=1dacede2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dacede2",
  null
  
)

export default component.exports